import { useEffect } from 'react';
import useTypedPage from './useTypedPage';
import { usePostHog } from 'posthog-js/react/dist/umd/index.js';

export default function useTrackingHook() {
  const {
    auth: { user },
  } = useTypedPage().props;
  const posthog = usePostHog();

  useEffect(() => {
    if (user && posthog) {
      const firstName = user.name.split(' ')[0];
      posthog.identify(`user:${user.id}`, {
        email: user.email,
        name: firstName,
        full_name: user.name,
      });
    }
  }, [posthog, user]);

  function track(name: string, props?: {}) {
    posthog?.capture(name, props);
  }

  return { track };
}
